import React from 'react'
import InputMask from 'react-input-mask'

import FormInput, { FormInputProps } from './FormInput'

export type FormMaskInputProps = Omit<FormInputProps, 'onChange' | 'disabled'> & {
  mask: string | (string | RegExp)[]
  onChange?: (val: string) => void
  disabled?: boolean
}

function FormMaskInput({ className, style, mask, value: _value, ...rest }: FormMaskInputProps) {
  const [value, setValue] = React.useState(_value ?? '')

  React.useEffect(() => {
    setValue(_value ?? '')
  }, [_value])

  return (
    <InputMask
      mask={mask}
      onChange={(e) => {
        setValue(e.target.value)
        rest.onChange?.(e.target.value)
      }}
      value={value}
      disabled={rest.disabled}
    >
      <FormInput
        {...{
          ...rest,
          onBlur: undefined,
          onChange: undefined,
        }}
      />
    </InputMask>
  )
}

export default FormMaskInput
